import gql from 'graphql-tag'

export const CREATE_USER = gql`
  mutation CreateUser(
    $name: String!
    $email: String!
    $profile: String!
    $role: String
  ) {
    createUser(
      name: $name
      email: $email
      profile: $profile
      role: $role
    ) {
      id
    }
  }
`
